<template>
  <transition name="fade">
    <div class="popup" v-if="options.content" :style="options.styles">
      <div class="button action close"
           @click="onClose"
           v-if="options.hasCloseButton">&times;</div>
      <div class="content" v-html="options.content"></div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'Popup',

    props: ['options'],

    methods: {
      onClose() {
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/styles/mixins";
  @import "../../assets/styles/animations";

  .popup {
    background-color: #f7f7f7;
    @include border-radius(4px);
    position: fixed;
    top: 50%;
    left: 50%;
    @include transform-translate(-50%, -50%);
    @include box-shadow(0 0 10px rgba(0, 0, 0, 0.5));
    text-align: initial;
    max-height: 100vh;
    overflow: auto;

    .action.close {
      position: absolute;
      top: 5px;
      right: 9px;
      color: #9e9e9e;
      cursor: pointer;
      font-size: 1.5em;
      line-height: 1;

      &:hover {
        color: #000000;
      }
    }

    .content {
      padding: 20px;
      @include user-select(text);
    }
  }
</style>
